import React from 'react';
import MainLayout from '../layouts/MainLayout';

const AGBPage = () => {
  return (
    <MainLayout
      title="Allgemeine Geschäftsbedingungen | SENKAY Personal & Logistik"
      description="Allgemeine Geschäftsbedingungen der SENKAY Personal & Logistik für Personaldienstleistungen und Logistiklösungen"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-primary-text-dark mb-8">
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="prose prose-lg max-w-none">
          <div className="bg-primary-blue-light/30 rounded-xl p-6 mb-8">
            <p className="text-sm text-primary-text-muted mb-2">
              <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE')}
            </p>
            <p className="text-sm text-primary-text-muted mb-0">
              <strong>Gültig für:</strong> SENKAY Personal & Logistik, Hilal Kaygisiz, Georg-Maurer-Weg 11, 80995 München
            </p>
          </div>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 1 Geltungsbereich</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Anwendungsbereich</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Geschäftsbeziehungen
              zwischen SENKAY Personal & Logistik, Hilal Kaygisiz, Georg-Maurer-Weg 11, 80995 München
              (nachfolgend "Auftragnehmer" oder "SENKAY") und seinen Auftraggebern (nachfolgend "Auftraggeber"
              oder "Kunde") im Bereich der Arbeitnehmerüberlassung, Personalvermittlung, Facility Management,
              Event-Logistik und sonstiger Dienstleistungen.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Ausschließliche Geltung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Diese AGB gelten ausschließlich. Entgegenstehende oder von diesen AGB abweichende Bedingungen
              des Auftraggebers erkennt SENKAY nicht an, es sei denn, SENKAY hätte ausdrücklich schriftlich
              ihrer Geltung zugestimmt. Diese AGB gelten auch dann, wenn SENKAY in Kenntnis entgegenstehender
              oder abweichender Bedingungen des Auftraggebers die Leistung vorbehaltlos ausführt.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Vertragspartner</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die AGB gelten gegenüber Unternehmern im Sinne des § 14 BGB, juristischen Personen des
              öffentlichen Rechts und öffentlich-rechtlichen Sondervermögen. Verbraucher im Sinne des
              § 13 BGB sind vom Anwendungsbereich dieser AGB ausgeschlossen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 2 Vertragsschluss und Leistungsumfang</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Angebot und Annahme</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Angebote von SENKAY sind freibleibend und unverbindlich, sofern nicht ausdrücklich als
              verbindlich gekennzeichnet. Ein Vertrag kommt erst durch die schriftliche Auftragsbestätigung
              von SENKAY oder durch Beginn der Leistungserbringung zustande.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Leistungsbeschreibung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Art und Umfang der zu erbringenden Leistungen ergeben sich aus der Auftragsbestätigung bzw.
              dem zwischen den Parteien geschlossenen Vertrag. Änderungen oder Ergänzungen bedürfen der
              Schriftform.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Pflichten des Auftraggebers</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der Auftraggeber ist verpflichtet, SENKAY alle für die Leistungserbringung erforderlichen
              Informationen vollständig und rechtzeitig zur Verfügung zu stellen. Dies umfasst insbesondere:
            </p>
            <ul className="list-disc pl-6 mb-4 text-primary-text-muted">
              <li>Genaue Beschreibung der auszuführenden Tätigkeiten</li>
              <li>Erforderliche Qualifikationen und Zertifikate</li>
              <li>Arbeitszeiten und Einsatzorte</li>
              <li>Besondere Anforderungen oder Sicherheitsvorschriften</li>
              <li>Notwendige Schutzausrüstung und Arbeitsmittel</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 3 Arbeitnehmerüberlassung</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Erlaubnis</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              SENKAY verfügt über die erforderliche Erlaubnis zur Arbeitnehmerüberlassung gemäß § 1 AÜG
              und überlässt dem Auftraggeber (Entleiher) Arbeitnehmer (Leiharbeitnehmer) zur Arbeitsleistung.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Weisungsrecht</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der überlassene Arbeitnehmer ist während der Überlassungsdauer arbeitsrechtlich bei SENKAY
              angestellt. Das Weisungsrecht hinsichtlich Zeit, Dauer, Ort und Art der Arbeitsausführung
              steht dem Auftraggeber zu. Das Weisungsrecht des Auftraggebers erstreckt sich nicht auf die
              Beendigung des Arbeitsverhältnisses zwischen SENKAY und dem Leiharbeitnehmer.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Überlassungshöchstdauer</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Überlassungshöchstdauer beträgt gemäß § 1 Abs. 1b AÜG grundsätzlich 18 aufeinanderfolgende
              Monate an denselben Entleiher. Abweichende tarifvertragliche Regelungen bleiben vorbehalten.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(4) Equal Pay</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Nach neun Monaten Einsatz beim Auftraggeber besteht gemäß § 8 AÜG Anspruch auf gleiches
              Arbeitsentgelt wie vergleichbare Stammmitarbeiter (Equal Pay), sofern keine abweichenden
              tarifvertraglichen Regelungen gelten.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(5) Pflichten des Entleihers</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der Auftraggeber verpflichtet sich:
            </p>
            <ul className="list-disc pl-6 mb-4 text-primary-text-muted">
              <li>Die gesetzlichen Arbeitssicherheits- und Unfallverhütungsvorschriften einzuhalten</li>
              <li>Dem Leiharbeitnehmer die erforderlichen Arbeitsmittel bereitzustellen</li>
              <li>SENKAY über alle relevanten betrieblichen Regelungen zu informieren</li>
              <li>Fehlzeiten und Arbeitszeitnachweise unverzüglich zu melden</li>
              <li>Den Leiharbeitnehmer über freie Arbeitsplätze zu informieren</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 4 Preise und Zahlungsbedingungen</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Vergütung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Vergütung richtet sich nach der jeweils gültigen Preisvereinbarung. Alle Preise verstehen
              sich zuzüglich der gesetzlichen Umsatzsteuer in der jeweils gültigen Höhe.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Abrechnung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Abrechnung erfolgt auf Grundlage der tatsächlich geleisteten Arbeitsstunden bzw. der
              vereinbarten Pauschale. Der Auftraggeber ist verpflichtet, die vom Leiharbeitnehmer
              geleisteten Arbeitsstunden durch Unterschrift auf dem Stundennachweis zu bestätigen.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Zahlungsbedingungen</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zur Zahlung fällig.
              Bei Zahlungsverzug werden Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz
              berechnet. Die Geltendmachung eines höheren Verzugsschadens bleibt vorbehalten.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(4) Aufrechnung und Zurückbehaltung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der Auftraggeber kann nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen
              aufrechnen. Ein Zurückbehaltungsrecht steht dem Auftraggeber nur zu, soweit sein Gegenanspruch
              auf demselben Vertragsverhältnis beruht.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 5 Leistungszeit und Verzug</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Leistungsfristen</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Termine und Fristen sind nur dann verbindlich, wenn sie von SENKAY ausdrücklich schriftlich
              als verbindlich bestätigt wurden. SENKAY bemüht sich, vereinbarte Termine einzuhalten,
              übernimmt jedoch keine Garantie für die Verfügbarkeit bestimmter Personen.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Höhere Gewalt</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Bei höherer Gewalt, Arbeitskampf, behördlichen Eingriffen und sonstigen unvorhersehbaren,
              unabwendbaren und schwerwiegenden Ereignissen verlängern sich die Leistungsfristen um die
              Dauer der Behinderung. SENKAY wird den Auftraggeber über solche Umstände unverzüglich
              informieren.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 6 Personalgestellung und -austausch</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Personalauswahl</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              SENKAY wählt die einzusetzenden Mitarbeiter nach bestem Wissen und unter Berücksichtigung
              der Anforderungen des Auftraggebers aus. Eine Garantie für die Eignung bestimmter Personen
              wird nicht übernommen.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Personalersatz</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Bei berechtigten Beanstandungen wird SENKAY nach eigenem Ermessen einen Ersatzmitarbeiter
              stellen. Der Auftraggeber hat keinen Anspruch auf Einsatz bestimmter Personen. Beanstandungen
              sind unverzüglich, spätestens innerhalb von 2 Arbeitstagen schriftlich anzuzeigen.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Direkteinstellung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Bei Direkteinstellung eines überlassenen Arbeitnehmers durch den Auftraggeber während der
              Überlassungszeit oder innerhalb von 12 Monaten nach Beendigung der Überlassung ist eine
              Vermittlungsprovision in Höhe von 3 Bruttomonatsgehältern des Arbeitnehmers zu zahlen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 7 Haftung</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Haftungsumfang</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              SENKAY haftet für Vorsatz und grobe Fahrlässigkeit. Bei leicht fahrlässiger Verletzung
              wesentlicher Vertragspflichten (Kardinalpflichten) ist die Haftung auf den vertragstypischen,
              vorhersehbaren Schaden begrenzt. Wesentliche Vertragspflichten sind solche, deren Erfüllung
              die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren
              Einhaltung der Vertragspartner regelmäßig vertrauen darf.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Produkthaftung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Personenschäden</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Haftung für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit
              bleibt unberührt.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(4) Haftung des Auftraggebers</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der Auftraggeber haftet für Schäden, die überlassene Arbeitnehmer während des Einsatzes
              beim Auftraggeber erleiden, soweit diese auf Pflichtverletzungen des Auftraggebers beruhen.
              Der Auftraggeber stellt SENKAY von Ansprüchen Dritter frei, die aus einem schuldhaften
              Verhalten des Auftraggebers resultieren.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 8 Vertraulichkeit und Datenschutz</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Vertraulichkeit</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Beide Vertragsparteien verpflichten sich, alle im Rahmen der Geschäftsbeziehung bekannt
              gewordenen vertraulichen Informationen geheim zu halten und nur zur Erfüllung des Vertrages
              zu verwenden.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Datenschutz</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Beide Parteien verpflichten sich zur Einhaltung der datenschutzrechtlichen Bestimmungen,
              insbesondere der DSGVO. Personenbezogene Daten werden nur im erforderlichen Umfang und
              zweckgebunden verarbeitet. Weitere Informationen zum Datenschutz finden Sie in unserer
              Datenschutzerklärung.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 9 Kündigung und Vertragslaufzeit</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Vertragslaufzeit</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Vertragslaufzeit ergibt sich aus der jeweiligen Auftragsbestätigung. Bei unbefristeten
              Verträgen gilt eine Kündigungsfrist von 4 Wochen zum Monatsende.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Außerordentliche Kündigung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. Ein
              wichtiger Grund liegt insbesondere vor bei:
            </p>
            <ul className="list-disc pl-6 mb-4 text-primary-text-muted">
              <li>Zahlungsverzug von mehr als 2 Monaten</li>
              <li>Eröffnung eines Insolvenzverfahrens</li>
              <li>Erheblichen Verstößen gegen vertragliche Pflichten</li>
              <li>Wegfall der Geschäftsgrundlage</li>
            </ul>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Folgen der Kündigung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Bei Beendigung des Vertrages sind alle bis dahin erbrachten Leistungen abzurechnen.
              Bereits fällige Forderungen bleiben bestehen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 10 Schlussbestimmungen</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(1) Schriftform</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Änderungen und Ergänzungen dieser AGB sowie des Vertrages bedürfen zu ihrer Wirksamkeit
              der Schriftform. Dies gilt auch für die Aufhebung des Schriftformerfordernisses.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(2) Anwendbares Recht</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des
              UN-Kaufrechts (CISG).
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(3) Gerichtsstand</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus diesem
              Vertrag ist München, sofern der Auftraggeber Kaufmann, juristische Person des öffentlichen
              Rechts oder öffentlich-rechtliches Sondervermögen ist.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">(4) Salvatorische Klausel</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die
              Wirksamkeit der übrigen Bestimmungen nicht. Die unwirksame Bestimmung ist durch eine
              wirksame zu ersetzen, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am
              nächsten kommt.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">§ 11 Kontakt und Beschwerden</h2>

            <p className="text-primary-text-muted leading-relaxed mb-4">
              Bei Fragen oder Beschwerden zu unseren Dienstleistungen stehen wir Ihnen gerne zur Verfügung:
            </p>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-primary-gray-border">
              <p className="text-primary-text-dark font-semibold mb-4">
                SENKAY Personal & Logistik
              </p>
              <p className="text-primary-text-muted mb-2">
                Hilal Kaygisiz<br />
                Georg-Maurer-Weg 11<br />
                80995 München<br />
                Deutschland
              </p>
              <p className="text-primary-text-muted mb-2">
                Telefon: <a href="tel:+4917762766603" className="text-primary-blue-mid hover:underline">+49 177 6276603</a><br />
                E-Mail: <a href="mailto:kontakt@senkay-personallogistik.de" className="text-primary-blue-mid hover:underline">kontakt@senkay-personallogistik.de</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};

export default AGBPage;
